export default __webpack_public_path__ + "static/media/forgot-min.7394a26b.jpg";